import { Route } from "react-router";
import { all_routes } from "./all_routes";
import ContactDetails from "../crm/customers";
import Deals from "../crm/deals";
import DealsDetails from "../crm/deals/dealsDetails";
import DealsKanban from "../crm/deals/dealsKanban";

import Register from "../auth/register";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/ResetPassword";
import AgentSetup from "../auth/AgentSetup";
import LeadsDetails from "../crm/leads";
import Leads from "../crm/leads/leads";
import Login from "../auth/login";
import Profile from "../settings/generalSettings/profile";
import CallerSettings from "../crm/settings/CallerSettings";
import ContactList from "../crm/customers/customerList";
import LeadsKanban from "../crm/leads/leadskanban";
import ContactGrid from "../crm/customers/customer-kanban";

import Pipeline from "../crm/pipeline";
import AgentDashboard from "../crm/agent-dashboard/Dashboard";
import AdminDashboard from "../crm/admin-dashboard/Dashboard";
import UserDashboard from "../crm/dashboard/Dashboard";
import LinkusClient from "../crm/linkus/LinkusClient";
import ScriptGenerator from "../crm/scriptGenerator/ScriptGenerator";
import ContactFaq from "../crm/leads/ContactFaq";
import AllCalls from "../crm/speakToLead/AllCalls";
import Api from "../crm/settings/Api";
import HelpAndSupport from "../crm/help-and-support/HelpAndSupport";
import SyncAndIntegration from "../crm/settings/SyncAndIntegration";
import ImportAndExport from "../crm/settings/ImportAndExport";
import UpgradePlan from "../crm/plans/UpgradePlan";
import Security from "../crm/settings/Security";
import Calendar from "../crm/calendar/Calendar";
import Agents from "../crm/agents/Agents";
import MyTickets from "../crm/help-and-support/MyTickets";
import CallLogsAndRecordings from "../crm/call-logs-and-recordings/CallLogsAndRecordings";
import ContactStatuses from "../crm/contact-statuses/ContactStatuses";
import ManageTickets from "../crm/settings/generalSettings/ManageTickets";
import ManageCompanies from "../crm/settings/generalSettings/ManageCompanies";
import CompanyDetails from "../crm/settings/generalSettings/CompanyDetails";
import AgentCallLogsAndRecordings from "../crm/agent-call-logs-and-recordings/AgentCallLogsAndRecordings";
import LinkLogin from "../otherPages/LinkLogin";
import Templates from "../crm/templates/Templates";
import ManageSuspendedCompanies from "../crm/settings/generalSettings/ManageSuspendedCompanies";
import Whatsapp from "../crm/chat/whatsapp/chat";
import WabaCampaigns from "../crm/chat/whatsapp/campaigns/WabaCampaigns";
import WabaTemplates from "../crm/chat/whatsapp/templates/WabaTemplates";
import WabaSetting from "../crm/chat/whatsapp/setting/WabaSetting";
import WabaAutomation from "../crm/chat/whatsapp/automation/WabaAutomation";
import FlowBuilder from "../crm/chat/whatsapp/automation/FlowBuilder";
import MetaFlowsPage from "../crm/chat/whatsapp/flows";
import WabaAddCampaign from "../crm/chat/whatsapp/campaigns/WabaAddCampaign";
import WabaCampaignDetails from "../crm/chat/whatsapp/campaigns/WabaCampaignDetails";
import WabaDataLoader from "../crm/chat/whatsapp/WabaDataLoader";
import Groups from "../crm/groups/Groups";
import WabaAddTemplate from "../crm/chat/whatsapp/templates/WabaAddTemplate";
import Devices from "../crm/admin-manageDevices/Devices";
import DeviceDetails from "../crm/admin-manageDevices/DeviceDetails";
import AdminPlans from "../crm/plans/AdminPlans";
import AdminCoupons from "../crm/plans/AdminCoupons";
import AdminApiLogs from "../crm/admin-api-logs/AdminApiLogs";
import AdminUserSessions from "../crm/admin-user-sessions/AdminUserSessions";
import AdminUserActivity from "../crm/admin-user-activity/AdminUserActivity";
import CompanyBilling from "../crm/plans/CompanyBilling";
import Credits from "../crm/plans/Credits";
import AdminNotifications from "../crm/plans/AdminNotifications";
import AdminEmailNotification from "../crm/plans/AdminEmailNotification";
import AdminWhatsappCampaigns from "../crm/plans/AdminWhatsappCampaigns";
import AdminWhatsappAddCampaign from "../crm/plans/AdminWhatsappAddCampaign";
import AdminWhatsappCampaignDetails from "../crm/plans/AdminWhatsappCampaignDetails";
import AdminWhatsappChat from "../crm/chat/whatsapp/chat";
import SuperAdminDashboard from "../crm/superadmin-dashboard/SuperAdminDashboard";
import AdminWhatsappTemplates from "../crm/chat/whatsapp/templates/WabaTemplates";
import AdminWhatsappAddTemplate from "../crm/chat/whatsapp/templates/WabaAddTemplate";
import AdminWhatsappSetting from "../crm/chat/whatsapp/setting/WabaSetting";
import BrowseNumbers from "../crm/did/BrowseNumbers";
import NumberCart from "../crm/did/NumberCart";
import MyNumbers from "../crm/did/MyNumbers";
import AssignNumbers from "../crm/did/AssignNumbers";
import CallHistory from "../crm/did/CallHistory";
import KYCDocuments from "../crm/did/KYCDocuments";
import CallRates from "../crm/did/CallRates";
import AdminDIDSettings from "../crm/did/AdminDIDSettings";
import AdminDIDNumbers from "../crm/did/AdminDIDNumbers";
import PowerDialerCampaigns from "../crm/power-dialer/PowerDialerCampaigns";
import PowerDialerLists from "../crm/power-dialer/PowerDialerLists";
import SystemEmails from "../crm/admin/SystemEmails";
import AdminBilling from "../crm/admin/AdminBilling";

const route = all_routes;

export const publicRoutes = [
  ////role : companyAdmin
  {
    path: route.linkusClient,
    name: "Linkus Client",
    element: <LinkusClient />,
    route: Route,
    title: "Linkus Client",
  },
  {
    path: route.dashboard,
    name: "Dashboard",
    element: <UserDashboard />,

    route: Route,
    title: "Dashboard",
  },
  {
    path: route.templates,
    element: <Templates />,
    route: Route,
    title: "Templates",
  },
  {
    path: route.contact_statuses,
    name: "Contact Statuses",
    element: <ContactStatuses />,

    route: Route,
    title: "Contact Statuses",
  },
  {
    path: route.scriptGenerator,
    name: "Script Generator",
    element: <ScriptGenerator />,
    route: Route,
    title: "Script Generator",
  },
  {
    path: route.leadsKanban,
    element: <LeadsKanban />,
    route: Route,
    title: "Leads Kanban",
  },
  {
    path: route.contactDetails,
    element: <ContactDetails />,
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.security,
    element: <Security />,
    route: Route,
    title: "Security",
  },
  {
    path: route.upgradePlan,
    element: <UpgradePlan />,
    route: Route,
    title: "Upgrade Plan",
  },
  {
    path: route.billing,
    element: <CompanyBilling />,
    route: Route,
    title: "Billing",
  },
  {
    path: route.credits,
    element: <Credits />,
    route: Route,
    title: "Credits",
  },
  {
    path: route.calendar,
    element: <Calendar />,
    route: Route,
    title: "Calendar",
  },
  {
    path: route.agents,
    element: <Agents />,
    route: Route,
    title: "Agents",
  },

  {
    path: route.deals,
    element: <Deals />,
    route: Route,
    title: "Deals",
  },
  {
    path: route.dealsDetails,
    element: <DealsDetails />,
    route: Route,
    title: "Deals Details",
  },
  {
    path: route.dealsKanban,
    element: <DealsKanban />,
    route: Route,
    title: "Deals Kanban",
  },
  {
    path: route.leadsDetails,
    element: <LeadsDetails />,
    route: Route,
    title: "Leads Details",
  },
  {
    path: route.leads,
    element: <Leads />,
    route: Route,
    title: "Leads",
  },
  {
    path: route.contactFaq,
    element: <ContactFaq />,
    route: Route,
    title: "Contact FAQ",
  },
  {
    path: route.allCalls,
    element: <AllCalls />,
    route: Route,
    title: "Calls",
  },
  {
    path: route.api,
    element: <Api />,
    route: Route,
    title: "Api",
  },
  {
    path: route.helpAndSupport,
    element: <HelpAndSupport />,
    route: Route,
    title: "Help And Support",
  },
  {
    path: route.myTickets,
    element: <MyTickets />,
    route: Route,
    title: "My Tickets",
  },
  {
    path: route.syncAndIntegration,
    element: <SyncAndIntegration />,
    route: Route,
    title: "Sync And Integration",
  },
  {
    path: route.importAndExport,
    element: <ImportAndExport />,
    route: Route,
    title: "Import And Export",
  },
  {
    path: route.profile,
    element: <Profile />,
    route: Route,
    title: "Profile",
  },
  {
    path: route.callerSettings,
    element: <CallerSettings />,
    route: Route,
    title: "Dialer Settings",
  },
  {
    path: route.contactList,
    element: <ContactList />,
    route: Route,
    title: "Contact List",
  },
  // {
  //   path: route.Whatsapp,
  //   element: <Whatsapp />,
  //   route: Route,
  //   title: "Whatsapp",
  // },
  {
    path: route.contactGrid,
    element: <ContactGrid />,
    route: Route,
    title: "Contact Grid",
  },
  {
    path: route.pipeline,
    element: <Pipeline />,
    route: Route,
    title: "Pipeline",
  },
  {
    path: route.myTickets,
    name: "Tickets",
    element: <MyTickets />,
    route: Route,
    title: "Tickets",
  },
  {
    path: route.callAndRecording,
    name: "Call Logs and Recordings",
    element: <CallLogsAndRecordings />,
    route: Route,
    title: "Call Logs and Recordings",
  },
  {
    path: route.templates,
    element: <Templates />,
    route: Route,
    title: "Templates",
  },
  {
    path: route.whatsapp,
    element: <WabaDataLoader><Whatsapp /></WabaDataLoader>,
    route: Route,
    title: "Whatsapp",
  },
  {
    path: route.whatsappHistory,
    element: <WabaDataLoader><Whatsapp /></WabaDataLoader>,
    route: Route,
    title: "Whatsapp History",
  },
  {
    path: route.wabaCampaigns,
    element: <WabaDataLoader><WabaCampaigns /></WabaDataLoader>,
    route: Route,
    title: "Campaigns",
  },
  {
    path: route.wabaAddCampaign,
    element: <WabaDataLoader><WabaAddCampaign /></WabaDataLoader>,
    route: Route,
    title: "Add Campaign",
  },
  {
    path: route.wabaCampaignDetails,
    element: <WabaDataLoader><WabaCampaignDetails /></WabaDataLoader>,
    route: Route,
    title: "Campaign Details",
  },
  {
    path: route.wabaTemplates,
    element: <WabaDataLoader><WabaTemplates /></WabaDataLoader>,
    route: Route,
    title: "Templates",
  },
  {
    path: route.wabaAddTemplate,
    element: <WabaDataLoader><WabaAddTemplate /></WabaDataLoader>,
    route: Route,
    title: "Templates",
  },
  {
    path: route.wabaSetting,
    element: <WabaSetting />,
    route: Route,
    title: "Setting",
  },
  {
    path: route.wabaAutomation,
    element: <WabaAutomation />,
    route: Route,
    title: "WhatsApp Automation",
  },
  {
    path: "/whatsapp/automation/flows/:id",
    element: <FlowBuilder />,
    route: Route,
    title: "Flow Builder",
  },
  {
    path: route.wabaMetaFlows,
    element: <MetaFlowsPage />,
    route: Route,
    title: "WhatsApp Flows",
  },
  {
    path: route.groups,
    element: <Groups />,
    route: Route,
    title: "Groups",
  },

  // DIDLogic — Phone Numbers & Calling
  {
    path: route.didBrowseNumbers,
    element: <BrowseNumbers />,
    route: Route,
    title: "Browse Numbers",
  },
  {
    path: route.didNumberCart,
    element: <NumberCart />,
    route: Route,
    title: "Number Cart",
  },
  {
    path: route.didMyNumbers,
    element: <MyNumbers />,
    route: Route,
    title: "My Numbers",
  },
  {
    path: route.didAssignNumbers,
    element: <AssignNumbers />,
    route: Route,
    title: "Assign Numbers",
  },
  {
    path: route.didCallHistory,
    element: <CallHistory />,
    route: Route,
    title: "Call History",
  },
  {
    path: route.didKycDocuments,
    element: <KYCDocuments />,
    route: Route,
    title: "KYC Documents",
  },
  {
    path: route.callRates,
    element: <CallRates />,
    route: Route,
    title: "Call Rates",
  },

  // Power Dialer
  {
    path: route.powerDialer,
    element: <PowerDialerCampaigns />,
    route: Route,
    title: "Power Dialer",
  },
  {
    path: route.powerDialerLists,
    element: <PowerDialerLists />,
    route: Route,
    title: "Power Dialer Lists",
  },
];

export const authRoutes = [
  {
    path: route.register,
    element: <Register />,
    route: Route,
    title: "Register",
  },
  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    title: "Forgot Password",
  },
  {
    path: route.resetPassword,
    element: <ResetPassword />,
    route: Route,
    title: "Reset Password",
  },
  {
    path: route.agentSetup,
    element: <AgentSetup />,
    route: Route,
    title: "Agent Setup",
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title: "Login",
  },
  // {
  //   path: route.linkLogin,
  //   element: <LinkLogin />,
  //   route: Route,
  //   title: "LinkLogin",
  // },
];

export const adminRoutes = [
  ////role : superAdmin
  // {
  //   path: route.adminDashboard,
  //   name: "Companies",
  //   element: <ManageCompanies />,
  //   route: Route,
  //   title: "Companies",
  // },
  {
    path: route.manageTickets,
    element: <ManageTickets />,
    route: Route,
    title: "Manage Tickets",
  },
  {
    path: route.adminDashboard,
    element: <SuperAdminDashboard />,
    route: Route,
    title: "Dashboard",
  },
  {
    path: route.adminCompaniesList,
    element: <ManageCompanies />,
    route: Route,
    title: "Companies",
  },
  {
    path: route.adminDevices,
    element: <Devices />,
    route: Route,
    title: "Manage Devices",
  },
  {
    path: route.deviceDetails,
    element: <DeviceDetails />,
    route: Route,
    title: "Device Details",
  },

  {
    path: route.companyDetails,
    element: <CompanyDetails />,
    route: Route,
    title: "Companies",
  },
  {
    path: route.adminProfile,
    element: <Profile />,
    route: Route,
    title: "Agent Profile",
  },
  {
    path: route.adminSecurity,
    element: <Security />,
    route: Route,
    title: "Agent Security",
  },
  {
    path: route.suspendedCompaniesList,
    element: <ManageSuspendedCompanies />,
    route: Route,
    title: "Suspended Companies",
  },
  {
    path: route.adminPlans,
    element: <AdminPlans />,
    route: Route,
    title: "Manage Plans",
  },
  {
    path: route.adminCoupons,
    element: <AdminCoupons />,
    route: Route,
    title: "Manage Coupons",
  },
  {
    path: route.adminDirectNotification,
    element: <AdminNotifications />,
    route: Route,
    title: "Direct Notification",
  },
  {
    path: route.adminEmailNotification,
    element: <AdminEmailNotification />,
    route: Route,
    title: "Email Notification",
  },
  {
    path: route.adminWhatsappCampaigns,
    element: <AdminWhatsappCampaigns />,
    route: Route,
    title: "WhatsApp Campaigns",
  },
  {
    path: route.adminWhatsappAddCampaign,
    element: <AdminWhatsappAddCampaign />,
    route: Route,
    title: "Create WhatsApp Campaign",
  },
  {
    path: route.adminWhatsappCampaignDetails,
    element: <AdminWhatsappCampaignDetails />,
    route: Route,
    title: "Campaign Details",
  },
  {
    path: route.adminWhatsappChat,
    element: <AdminWhatsappChat />,
    route: Route,
    title: "WhatsApp Chat",
  },
  {
    path: route.adminWhatsappHistory,
    element: <AdminWhatsappChat />,
    route: Route,
    title: "WhatsApp History",
  },
  {
    path: route.adminWhatsappTemplates,
    element: <AdminWhatsappTemplates />,
    route: Route,
    title: "WhatsApp Templates",
  },
  {
    path: route.adminWhatsappAddTemplate,
    element: <AdminWhatsappAddTemplate />,
    route: Route,
    title: "Add WhatsApp Template",
  },
  {
    path: route.adminWhatsappSetting,
    element: <AdminWhatsappSetting />,
    route: Route,
    title: "WhatsApp Settings",
  },
  {
    path: route.adminApiLogs,
    element: <AdminApiLogs />,
    route: Route,
    title: "API Logs",
  },
  {
    path: route.adminUserSessions,
    element: <AdminUserSessions />,
    route: Route,
    title: "User Sessions",
  },
  {
    path: route.adminUserActivity,
    element: <AdminUserActivity />,
    route: Route,
    title: "User Activity",
  },

  // DIDLogic Admin
  {
    path: route.adminDidNumbers,
    element: <AdminDIDNumbers />,
    route: Route,
    title: "DID Numbers",
  },
  {
    path: route.adminDidSettings,
    element: <AdminDIDSettings />,
    route: Route,
    title: "DID Settings",
  },
  {
    path: route.adminCallRates,
    element: <CallRates />,
    route: Route,
    title: "Call Rates",
  },
  {
    path: route.adminSystemEmails,
    element: <SystemEmails />,
    route: Route,
    title: "System Emails",
  },
  {
    path: route.adminBilling,
    element: <AdminBilling />,
    route: Route,
    title: "Admin Billing",
  },
];
export const agentRoutes = [
  ////role : user
  {
    path: route.agentProfile,
    element: <Profile />,
    route: Route,
    title: "Agent Profile",
  },
  {
    path: route.agentSecurity,
    element: <Security />,
    route: Route,
    title: "Agent Security",
  },
  {
    path: route.agentLinkusClient,
    name: "Agent Call Client",
    element: <LinkusClient />,
    route: Route,
    title: "Agent Call Client",
  },
  {
    path: route.agentDashboard,
    name: "Agent Dashboard",
    element: <AgentDashboard />,
    route: Route,
    title: "Agent Dashboard",
  },
  {
    path: route.agentHelpAndSupport,
    element: <HelpAndSupport />,
    route: Route,
    title: "Help And Support",
  },
  {
    path: route.myTicketsAgent,
    name: "Tickets",
    element: <MyTickets />,
    route: Route,
    title: "Tickets",
  },
  {
    path: "/agent/contact-statuses",
    name: "Contact Statuses",
    element: <ContactStatuses />,

    route: Route,
    title: "Contact Statuses",
  },
  {
    path: route.agentCallAndRecording,
    name: "Tickets",
    element: <AgentCallLogsAndRecordings />,
    route: Route,
    title: "Tickets",
  },
  {
    path: route.agentFaq,
    element: <ContactFaq />,
    route: Route,
    title: "Contact FAQ",
  },
  {
    path: route.agentSyncAndIntegration,
    element: <SyncAndIntegration />,
    route: Route,
    title: "Sync And Integration",
  },
  {
    path: route.agentImportAndExport,
    element: <ImportAndExport />,
    route: Route,
    title: "Import And Export",
  },
  {
    path: route.agentCalendar,
    element: <Calendar />,
    route: Route,
    title: "Calendar",
  },
  {
    path: route.agentLeads,
    element: <Leads />,
    route: Route,
    title: "Leads",
  },
  {
    path: route.agentContactList,
    element: <ContactList />,
    route: Route,
    title: "Contact List",
  },
  {
    path: route.agentContactDetails,
    element: <ContactDetails />,
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.agentLeadsDetails,
    element: <LeadsDetails />,
    route: Route,
    title: "Leads Details",
  },
  {
    path: route.agentWhatsapp,
    element: <Whatsapp />,
    route: Route,
    title: "Whatsapp",
  },
  {
    path: route.agentWhatsappHistory,
    element: <Whatsapp />,
    route: Route,
    title: "Whatsapp History",
  },
  {
    path: route.agentWabaCampaigns,
    element: <WabaCampaigns />,
    route: Route,
    title: "Campaigns",
  },
  {
    path: route.agentWabaAddCampaign,
    element: <WabaAddCampaign />,
    route: Route,
    title: "Add Campaign",
  },
  {
    path: route.agentWabaCampaignDetails,
    element: <WabaCampaignDetails />,
    route: Route,
    title: "Campaign Details",
  },
  {
    path: route.agentWabaTemplates,
    element: <WabaTemplates />,
    route: Route,
    title: "Templates",
  },
  {
    path: route.agentWabaAddTemplate,
    element: <WabaAddTemplate />,
    route: Route,
    title: "Templates",
  },
  {
    path: route.agentGroups,
    element: <Groups />,
    route: Route,
    title: "Groups",
  },
  {
    path: route.agentCallerSettings,
    element: <CallerSettings />,
    route: Route,
    title: "Dialer Settings",
  },

  // Power Dialer (agent)
  {
    path: route.agentPowerDialer,
    element: <PowerDialerCampaigns />,
    route: Route,
    title: "Power Dialer",
  },
  {
    path: route.agentPowerDialerLists,
    element: <PowerDialerLists />,
    route: Route,
    title: "Power Dialer Lists",
  },
];
